
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";

import { useConsumoXLote } from "../../../hooks";
import { DisenioLoteDistribuido } from "../../layout";
import { BusquedaSoloFecha, CargandoMedio, FBAFuncion, FormCreateConsumo, TablaConsumoLote, TarjetaResumenInfo } from "../../components";
import { useConsumosStore, useModalesStore } from "../../../store";
import { ModalFormUno } from "../../components/components/ModalFormUno";






export const ConsumoScreen = () => {


    const { id } = useParams();
    const { consumoXLoteQuery, page, chagePage, inicio, final, chageInicio, chageFinal } = useConsumoXLote(id);
    const { datosConsumo } = useConsumosStore();
    const { changeEstadoModalUno } = useModalesStore(); 


    const handleAbrilModal = () => {
        changeEstadoModalUno(true);
    }


    const handleCerrarModal = () => {
        changeEstadoModalUno(false);
    }



    return (

        <DisenioLoteDistribuido titulo="Registro de Consumo" >

            {consumoXLoteQuery.isLoading 
            ?   <CargandoMedio titulo="Cargando Información..." />
            :   <>
                <TarjetaResumenInfo data={datosConsumo} color={'#A67C52'} titulo="Resumen Consumo" />
                {(consumoXLoteQuery?.data?.length > 0) 
                ?   <>
                        <BusquedaSoloFecha inicio={inicio} final={final} chageInicio={chageInicio} chageFinal={chageFinal} />
                        <TablaConsumoLote data={consumoXLoteQuery.data || []} chagePage={chagePage} page={page} />
                    </>
                :   <Box></Box>
                }
                </>
            }

            <FBAFuncion funcion={ handleAbrilModal } icono="plus" />

            <ModalFormUno titulo="Agregar Consumo" valor={{}} onClose={handleCerrarModal}>
                <FormCreateConsumo />
            </ModalFormUno>
        </DisenioLoteDistribuido>

    )
}
